import copy from 'copy-to-clipboard';
import { Notification } from 'uiv';
import i18n from '@/i18n';

export default function CopyToClipboard(data: string, options = {}): void {
  const success = copy(data, options);

  if (!success) {
    Notification.notify.error({
      title: i18n.t('notifications.copyFail'),
      duration: 2000,
    });
    return;
  }

  Notification.notify.success({
    title: i18n.t('notifications.copySuccess'),
    duration: 1000,
  });
}
